<template>
  <div class="mx-auto text-black border-danger text-center m-5">
    <h1 class="text-uppercase mt-2">{{ productLabel }}</h1>
  </div>
  <div class="d-flex bd-highlight border">
    <div>
      <div
        class="m-4 d-flex justify-content-center align-items-center flex-column"
      >
        <img
          class="card-img mb-5 ImgFixMain no-select"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          :title="product.naam + ': ' + product.korteProductbeschrijving"
          :alt="productLabel"
          :src="mainImage"
          @click="openImage(mainImage)"
        />
      </div>

      <div class="prodImg" v-if="product.afbeeldingMeerdere != ''">
        <template v-for="(image, key) in altImages" :key="key">
          <img
            class="subImg ms-4 mt-1"
            :alt="product.naam"
            :src="image"
            @click="openImage(image)"
          />
        </template>
      </div>
      <div id="imageModal" class="modal">
        <span class="close" @click="closeImage()">&times;</span>
        <img class="modal-content" :src="modalImg" />
        <div id="caption">
          {{ product.kleur }}
        </div>
      </div>
    </div>
    <div class="prodOptionsFont ps-4 bg-light flex-fill bd-highlight">
      <div class="kleurOption px-2" v-if="steps == 1">
        <h2 class="mt-5 mb-4 text-uppercase" id="color-op">Kleur opties</h2>
        <template v-for="tile in tiles" :key="tile.index">
          <div
            class="d-inline-flex p-1 bd-highlight no-select"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            :title="tile.tooltip"
          >
            <router-link :to="{ name: tile.path }">
              <img :src="tile.image" class="colorPick" />
            </router-link>
          </div>
        </template>
      </div>

      <OrderStepper :product="product" v-on:stepper="step" />
    </div>
  </div>

  <Information :product="product" />
</template>
<script>
import OrderStepper from "@/components/OrderStepper";
import Information from "@/components/ProductInformation";

export default {
  name: "Specifications",
  components: {
    OrderStepper,
    Information,
  },
  data() {
    return {
      product: "",
      selection: "",
      tiles: {},
      mainImage: "",
      modalImg: "",
      altImages: [],
      steps: 1,
    };
    //end data
  },
  created() {
    this.loadPage();
    this.$store.commit("storeLocUpdate", true);
  },
  beforeUpdate() {
    this.loadPage();
    this.$store.commit("storeLocUpdate", true);
  },
  computed: {
    productLabel() {
      // build label
      let color = "";
      if (this.product.kleur !== undefined && this.product.kleur !== "") {
        if (this.product.kleur !== this.product.naam) {
          color = " " + this.product.kleur;
        }
      }

      return this.product.naam + color;
    },
  },
  methods: {
    // function to load the page on (re)load
    loadPage() {
      // get selection data
      this.selection = this.$Functions.getSelection(this.$route.name);

      // get collection data
      const collection = this.$Functions.getCollectionData(
        this.selection.assortmentCode,
        this.selection.collectionCode,
        this.$store.getters.getLang
      );

      let tiles = [];
      let iTiles = 0;

      for (let index in collection) {
        if (collection[index].kleurFilter !== "") {
          tiles[iTiles] = collection[index];
          iTiles++;
        }
      }

      // get product data
      this.product = this.$Functions.getProductData(
        this.selection.code,
        this.$store.getters.getLang
      );

      // get images
      this.mainImage = this.$Functions.getImage(this.product.afbeelding);
      this.altImages = this.getAltImages(this.product);

      // build collection tiles
      this.tiles = this.buildTiles(this.product, tiles);
    },
    getAltImages(product) {
      let images = [];
      if (product.afbeeldingMeerdere !== "") {
        for (const image in product.afbeeldingMeerdere) {
          if (
            product.afbeeldingMeerdere[image] !== "" &&
            product.afbeeldingMeerdere[image] !== undefined
          ) {
            images[image] = this.$Functions.getImage(
              product.afbeeldingMeerdere[image]
            );
          }
        }
      }
      return images;
      // end getAltImages
    },
    buildTiles(selectedProduct, collection) {
      let tiles = {};

      for (const iCollectie in collection) {
        if (
          selectedProduct.name + " " + selectedProduct.color !==
          collection[iCollectie].naam + " " + collection[iCollectie].kleur
        ) {
          let code = "";

          if (
            collection[iCollectie].code !== "" &&
            collection[iCollectie].code !== undefined
          ) {
            code = collection[iCollectie].code + " - ";
          }

          let color = "";
          if (
            collection[iCollectie].kleur !== "" &&
            collection[iCollectie].kleur !== undefined
          ) {
            if (collection[iCollectie].kleur !== collection[iCollectie].naam) {
              color = " - " + collection[iCollectie].kleur;
            }
          }

          let name = code + collection[iCollectie].naam + color;
          let route = `${this.selection.lang}-${collection[iCollectie].productCode}`;

          // get tool tip
          const toolTip = `${collection[iCollectie].naam} - ${collection[iCollectie].kleur}: ${collection[iCollectie].korteProductbeschrijving}`;

          tiles[name.replaceAll(" ", "")] = {
            tooltip: toolTip,
            path: route,
            image: this.$Functions.getImage(collection[iCollectie].afbeelding),
          };
        }
        // end loop collections
      }

      return tiles;
      // end build tiles
    },
    openImage(img) {
      this.modalImg = img;
      document.querySelector("#imageModal").style.display = "block";
    },
    closeImage() {
      document.querySelector("#imageModal").style.display = "none";
    },
    step(value) {
      this.steps = value;
      return value;
    },
    // end methode
  },
  watch: {
    "$route.name": function () {
      this.$store.commit("storeLocUpdate", true);
    },
  },
  // end export
};
</script>

<style lang=css>
 @import url("../styles/specifications.css");
</style>

<style scoped>
a {
  text-decoration: none;
}

.no-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
</style>
